
export default function HelpfulLinksSection() {
  const linkCategories = [
    {
      title: 'Quality Assurance',
      icon: 'ri-shield-check-line',
      color: 'blue',
      links: [
        {
          name: 'Quality Council for Trades and Occupations (QCTO)',
          url: 'www.qcto.org.za',
          description: 'Occupational qualifications and quality assurance'
        },
        {
          name: 'South African Qualifications Authority (SAQA)',
          url: 'www.saqa.org.za',
          description: 'National qualifications framework and standards'
        },
        {
          name: 'Council on Higher Education (CHE)',
          url: 'www.che.ac.za',
          description: 'Higher education quality assurance'
        }
      ]
    },
    {
      title: 'SETA Resources',
      icon: 'ri-government-line',
      color: 'green',
      links: [
        {
          name: 'W&RSETA - Wholesale & Retail',
          url: 'www.wrseta.org.za',
          description: 'Wholesale, retail, motor, and new tyre sectors'
        },
        {
          name: 'Services SETA',
          url: 'www.servicesseta.org.za',
          description: 'Business services and community services'
        },
        {
          name: 'MERSETA - Manufacturing & Engineering',
          url: 'www.merseta.org.za',
          description: 'Manufacturing, engineering, and related services'
        },
        {
          name: 'TETA - Transport',
          url: 'www.teta.org.za',
          description: 'Transport, logistics, and related services'
        }
      ]
    },
    {
      title: 'Government Resources',
      icon: 'ri-building-line',
      color: 'purple',
      links: [
        {
          name: 'Department of Higher Education and Training',
          url: 'www.dhet.gov.za',
          description: 'National skills development policy and oversight'
        },
        {
          name: 'South African Revenue Service (SARS)',
          url: 'www.sars.gov.za',
          description: 'Skills Development Levy information'
        }
      ]
    },
    {
      title: 'Industry Resources',
      icon: 'ri-briefcase-line',
      color: 'orange',
      links: [
        {
          name: 'B-BBEE Commission',
          url: 'www.bbbeecommission.co.za',
          description: 'Transformation and skills development'
        }
      ]
    }
  ];

  const getColorClasses = (color: string) => {
    const colors = {
      blue: 'bg-amber-100 text-amber-700 border-amber-200',
      green: 'bg-green-100 text-green-600 border-green-200',
      purple: 'bg-green-100 text-green-800 border-green-200',
      orange: 'bg-gray-100 text-brand-muted border-gray-200'
    };
    return colors[color as keyof typeof colors] || colors.blue;
  };

  return (
    <section className="section-wrap bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="section-heading">
            Helpful Links & Resources
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Essential external resources for skills development, compliance, and quality assurance
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {linkCategories.map((category, categoryIndex) => (
            <div key={categoryIndex} className="bg-gray-50 rounded-xl p-6">
              <div className="flex items-center mb-6">
                <div className={`w-12 h-12 rounded-lg flex items-center justify-center mr-4 ${getColorClasses(category.color)}`}>
                  <i className={`${category.icon} text-xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900">{category.title}</h3>
              </div>

              <div className="space-y-4">
                {category.links.map((link, linkIndex) => (
                  <div key={linkIndex} className="card p-4">
                    <div className="flex items-start justify-between mb-2">
                      <h4 className="font-semibold text-gray-900 text-sm">{link.name}</h4>
                      <div className="w-6 h-6 text-gray-400 flex items-center justify-center">
                        <i className="ri-external-link-line text-sm"></i>
                      </div>
                    </div>
                    <p className="text-gray-600 text-xs mb-2">{link.description}</p>
                    <div className="flex items-center">
                      <i className="ri-global-line text-gray-400 mr-2 text-sm"></i>
                      <span className="text-gray-500 text-xs">{link.url}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-[#2D7F3E] text-white p-8 rounded-xl text-center">
          <h3 className="text-2xl font-bold mb-4">Need Help Navigating These Resources?</h3>
          <p className="text-green-100 mb-6 max-w-2xl mx-auto">
            Our experts can guide you through the complex landscape of skills development regulations and requirements
          </p>
          <button className="btn btn-white">
            Get Expert Guidance
          </button>
        </div>
      </div>
    </section>
  );
}
